import { motion } from 'framer-motion';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import { request } from '../helpers/request';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await request(SummaryApi.forgotPassword, {
                body: JSON.stringify({ email: email })
            });

            const data = await response.json();

            if (data.success) {
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className='min-h-screen flex items-center justify-center bg-surface-muted py-20 px-6'>
            <motion.div 
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className='w-full max-w-md bg-white rounded-card shadow-premium p-10'
            >
                <div className='text-center mb-8'>
                    <h1 className='text-3xl font-black text-primary tracking-tight'>Reset Password</h1>
                    <p className='text-gray-500 font-medium mt-1'>Enter your email to receive a reset link.</p>
                </div>

                <form className='space-y-6' onSubmit={handleSubmit}>
                    <div className='space-y-1.5'>
                        <label className='text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1'>Email Address</label>
                        <div className='h-12 bg-surface-muted rounded-2xl border border-surface-border px-4 flex items-center focus-within:border-accent transition-all'>
                            <input
                                type='email'
                                placeholder='name@example.com'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className='w-full h-full outline-none bg-transparent font-bold text-primary placeholder:text-gray-300 text-sm'
                            />
                        </div>
                    </div>

                    <button 
                        disabled={loading}
                        className='w-full h-14 bg-primary text-white font-black text-lg rounded-full hover:bg-accent transition-all shadow-xl shadow-primary/20 active:scale-95 disabled:opacity-50'
                    >
                        {loading ? "Sending..." : "Send Reset Link"}
                    </button>
                </form>

                <p className='mt-8 text-center text-gray-400 font-bold text-sm'>
                    Remember your password? <Link to={'/login'} className='text-accent hover:underline'>Back to login</Link>
                </p>
            </motion.div>
        </section>
    );
};

export default ForgotPassword;
